import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-content">
          <div className="hero-badge">
            <span>PhD Economics | 15+ Years Experience</span>
          </div>
          
          <h1 className="hero-title">
            <span className="highlight">Dr. Dipti Vashisth Sharma</span>
          </h1>
          
          <p className="hero-subtitle">
            Assistant Professor | Researcher | Author | Patent Holder
          </p>

          {/* Expertise Section */}
          <div className="expertise-section">
            <h3>Areas of Expertise</h3>
            <div className="expertise-grid">
              <div className="expertise-item">
                <span className="expertise-icon">📊</span>
                <span>Financial Management</span>
              </div>
              <div className="expertise-item">
                <span className="expertise-icon">🌍</span>
                <span>International Business</span>
              </div>
              <div className="expertise-item">
                <span className="expertise-icon">📈</span>
                <span>Economic Analysis</span>
              </div>
              <div className="expertise-item">
                <span className="expertise-icon">🔬</span>
                <span>Research Methodology</span>
              </div>
            </div>
          </div>

          {/* Quick Stats */}
          <div className="quick-stats">
            <div className="stat">
              <div className="stat-number">34+</div>
              <div className="stat-label">Research Papers</div>
            </div>
            <div className="stat">
              <div className="stat-number">3</div>
              <div className="stat-label">Patents</div>
            </div>
            <div className="stat">
              <div className="stat-number">2</div>
              <div className="stat-label">Books</div>
            </div>
            <div className="stat">
              <div className="stat-number">15+</div>
              <div className="stat-label">Years Exp</div>
            </div>
          </div>
        </div>

        {/* Right Side - Photo */}
        <div className="hero-image">
          <div className="image-container">
            <img 
              src="../assets/profile.jpg"
              alt="Dr. Dipti Vashisth Sharma"
              onError={(e) => {
                e.target.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='500' viewBox='0 0 400 500'%3E%3Crect width='400' height='500' fill='%233945ab'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='Arial' font-size='24' fill='white'%3EDr. Dipti Sharma%3C/text%3E%3C/svg%3E"
              }}
            />
            <div className="image-overlay">
              <div className="current-role">
                <span>Recognized Research Guide</span>
                <span>Subject Matter Expert (Economics, Finance & International Business)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;